module.exports = __webpack_public_path__ + "img/oil-lamp-factory.5ad96afd.webp";